import { render, staticRenderFns } from "./ContentRouter.vue?vue&type=template&id=52d921e4"
import script from "./ContentRouter.vue?vue&type=script&lang=js"
export * from "./ContentRouter.vue?vue&type=script&lang=js"
import style0 from "./ContentRouter.vue?vue&type=style&index=0&id=52d921e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports